import { TeamProduct } from '@clipr/lib';

export const TeamProductValues = Object.keys(TeamProduct) as TeamProduct[];

export const getTeamProductSelectorItems = () => TeamProductValues.map(i => ({ value: i, label: i }));
export const getTeamProductLabel = (label: string): TeamProduct | undefined => TeamProductValues.find(i => i === label);